import { all, fork } from "redux-saga/effects";
import user from "./user/user.saga";
import company from "./company/company.saga";

export default function* rootSaga() {
  yield all([
    fork(user),
    fork(company),
  ])
}